import TrainplanService from '@/services/TrainplanService'

export const getVariant = params =>
  TrainplanService.get('/1/train-schedule-variant', {
    params
  })

export const get = params =>
  TrainplanService.get('/2/train-schedule', {
    params
  })
